import { useMemo } from 'react';
import {
  VDP_DEFERRED_REQUEST_KEYS,
  type VdpDeferredRequestKey
} from '~/constants/common/deferredRequests';
import { useResolvedOnServer } from '~/context/common/DeferredResolutionContext';
import { useConfiguration } from '~/context/common/StaticContext';

export type DeferredRequestState = {
  [key in VdpDeferredRequestKey]: {
    configured: boolean;
    resolvedOnServer: boolean;
  };
};

export function useGetDeferredRequests() {
  const { DeferredRequestsConfig: { enabled, requests: requestsConfig } = {} } =
    useConfiguration();
  const resolvedOnServer = useResolvedOnServer();

  return useMemo(
    () => ({
      enabled,
      requests: VDP_DEFERRED_REQUEST_KEYS.reduce<DeferredRequestState>(
        (acc, key) => {
          acc[key] = {
            configured: requestsConfig?.[key] ?? false,
            resolvedOnServer: resolvedOnServer[key] ?? false
          };

          return acc;
        },
        {} as DeferredRequestState
      )
    }),
    [enabled, requestsConfig, resolvedOnServer]
  );
}
